import { render, staticRenderFns } from "./BusstopInfo.vue?vue&type=template&id=0a399ed6&"
import script from "./BusstopInfo.vue?vue&type=script&lang=js&"
export * from "./BusstopInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports